import React, {useEffect, useState} from 'react';

const NotificationType = ({value, onChange}) => {

  const [notificationType, setNotificationType] = useState(value);

  useEffect(() => { onChange(notificationType); }, [notificationType]);

  return <div className="mb-3">
    <label className="form-label">Notification type</label>
    <div className="ms-md-5">
      <div className="form-check">
        <input type="radio"
               name="notification-type"
               id="email-to-org"
               className="form-check-input"
               value="email-to-org"
               checked={notificationType === 'email-to-org'}
               onChange={e => setNotificationType(e.target.value)}/>
        <label className="form-check-label" htmlFor="email-to-org">
          Email to someone in your organization
        </label>
      </div>
      <div className="form-check">
        <input type="radio"
               name="notification-type"
               id="email-to-customer"
               className="form-check-input"
               value="email-to-customer"
               checked={notificationType === 'email-to-customer'}
               onChange={e => setNotificationType(e.target.value)}/>
        <label className="form-check-label" htmlFor="email-to-customer">
          Confirmation email to your customer
        </label>
      </div>
    </div>
  </div>;
};

export default NotificationType;
